import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";

import Landing from "@/pages/Landing";
import ThemeSelector from "@/pages/ThemeSelector";
import ConceptSelector from "@/pages/ConceptSelector";
import Editor from "@/pages/Editor";
import InvitationView from "@/pages/InvitationView";
import GuestsView from "@/pages/GuestsView";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminPanel from "@/pages/AdminPanel";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id in URL fragment synchronously during render (not useEffect).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/crear" element={<ProtectedRoute><ThemeSelector /></ProtectedRoute>} />
      <Route path="/crear/:theme" element={<ProtectedRoute><ConceptSelector /></ProtectedRoute>} />
      <Route path="/crear/:theme/:concept/editor" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
      <Route path="/editor/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
      <Route path="/i/:slug" element={<InvitationView />} />
      <Route path="/preview/:token" element={<InvitationView />} />
      <Route path="/g/:slug" element={<GuestsView />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}
